module.exports = __webpack_public_path__ + "img/28.0bda06e0.png";